import { render } from "./UserRoleSelector.vue?vue&type=template&id=7c27a3ad"
import script from "./UserRoleSelector.vue?vue&type=script&lang=js"
export * from "./UserRoleSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__